import React from "react";
import { Star, MapPin } from "lucide-react";

export default function HotelCard({ hotel }) {
  const query = encodeURIComponent(`${hotel.name} ${hotel.area || ""} hotel room`);
  const img = `https://source.unsplash.com/featured/800x520/?${query}`;
  return (
    <div className="bg-white rounded-[1.5rem] overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-[#E8E8ED]" data-testid="hotel-card">
      <div className="aspect-[16/9] bg-[#F5F5F7] relative overflow-hidden">
        <img src={img} alt={hotel.name} className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        <div className="absolute top-3 left-3 text-[10px] px-2 py-1 rounded-full bg-white/90 backdrop-blur text-gray-600">Cadangan demo</div>
        {hotel.rating && (
          <div className="absolute top-3 right-3 text-xs px-2.5 py-1 rounded-full bg-[#0A2540] text-white flex items-center gap-1">
            <Star className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" /> {hotel.rating}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="text-[15px] font-semibold text-[#0A2540]">{hotel.name}</div>
        {hotel.area && <div className="text-xs text-gray-500 flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3" /> {hotel.area}</div>}
        {hotel.amenities?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-3">
            {hotel.amenities.slice(0, 4).map((a, i) => (
              <span key={i} className="text-[11px] px-2 py-0.5 rounded-full bg-[#F5F5F7] text-gray-600">{a}</span>
            ))}
          </div>
        )}
        {hotel.note && <div className="text-xs text-gray-500 mt-2">{hotel.note}</div>}
        <div className="mt-3 flex items-center justify-between">
          <div>
            <div className="text-[10px] text-gray-400">Anggaran / malam</div>
            <div className="text-lg font-semibold text-[#0A2540]">RM{Number(hotel.price_myr_per_night || 0).toLocaleString()}</div>
          </div>
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(hotel.name + " " + (hotel.area || ""))}`}
            className="chip text-xs px-3 py-1.5 rounded-full bg-[#F5F5F7] hover:bg-[#E8E8ED] text-[#1D1D1F]"
          >
            Lihat di peta
          </a>
        </div>
      </div>
    </div>
  );
}
